<template>
  <div>
        <div class="row">
      <h1 v-if="isShow" class="col-8 primary-text">{{ title }}</h1>
      <div v-if="isShow" class="col-4 text-left "><span @click="goToLists" class="primary-text ml-2 pointer"  >MORE</span> <i
          class="fa-solid fa-arrow-left fa-lg pointer"></i></div>
    </div>
    <div v-if="dataLoading" class="row align-items-center ">
      <div class="col-3 text-center">
        <v-skeleton-loader
            type="avatar"
        ></v-skeleton-loader>
      </div> <div class="col-3 text-center">
        <v-skeleton-loader
            type="avatar"
        ></v-skeleton-loader>
      </div> <div class="col-3 text-center">
        <v-skeleton-loader
            type="avatar"
        ></v-skeleton-loader>
      </div> <div class="col-3 text-center">
        <v-skeleton-loader
            type="avatar"
        ></v-skeleton-loader>
      </div>
    </div>
    <div v-else-if="categories.length > 0 && categories !== undefined" class="row">

      <div class="col-12" dir="ltr">
        <carousel
            v-if="categories.length >0"
            :autoplay="false"
            :autoplayTimeout="7000"
            :dots="false"
            :nav="true"
            :navText="navText"
            :responsive="{0:{items:5,margin:10},600:{items:5,margin:15},700:{items:6,margin:16},900:{items:8,margin:20},1200:{items:10,margin:25}}"
            :rtl="true"
            class="owl-carousel-post-card">
          <div @click="goToList(item.ShoppingCategoryID,item.ProductCategoryID,item.Name)" class="d-block" v-for="(item,i) in categories" :key="i">
            <div class=" rounded-lg ">
            <v-img :src="$replaceHttps(item.FileUrl)"
                   :lazy-src="$replaceHttps(item.FileUrl)"
                   aspect-ratio="1" contain class="bg-white rounded-lg"></v-img></div>
            <div class="text-center font12px mt-2 rounded-lg categories-title">{{ item.Name }}</div>
          </div>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";

export default {
  name: "ProductsOrStoreCategories",
  props: ['categories', 'title', 'dataLoading','isOnline'],

  components: {
    carousel,
  },
  data: () => ({
    navText: ['<i class="fa-solid fa-circle-chevron-left" aria-hidden="true"></i>'],
    isShow:true,
    isOnlinePayment:null
  }),
  mounted() {
    this.isShow = this.$router.currentRoute.path !== '/ProductsList' && this.$router.currentRoute.path !== '/StoreList';
    this.isOnlinePayment = this.isOnline
  },

  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
    goToList(ShoppingCategoryID,ProductCategoryID,name){
      if(this.$router.currentRoute.path === '/StoreList' || this.$router.currentRoute.path === '/OfflinePaymentHome'){
        this.$router.push({path: 'StoreList', query: {isOnline: this.isOnline, ShoppingCategoryID: ShoppingCategoryID,Name:name}})
      }else {
        this.$router.push({path: 'ProductsList', query: {isOnline: this.isOnline, ProductCategoryID: ProductCategoryID,Name:name}})
      }
    },
    goToLists(){
      if(this.isOnline === 'true'){
        this.$router.push({path:'ProductsList',query:{isOnline:this.isOnline}})
      }else {
        this.$router.push({path:'StoreList',query:{isOnline:this.isOnline}})

      }
    }
  }
}</script>

<style scoped>

</style>
